module.exports = __webpack_public_path__ + "media/images/extending-leads-a603a65db6ec5f7ff265802ac0afac4f.png";